import React from 'react';
import { initializeStore } from '../store/store';
import IconFlagRussian from '../components/UI/Icons/IconFlagRussian';
import IconFlagUSA from '../components/UI/Icons/IconFlagUSA';
import { reduxStateWithTranslations } from '../pages/_app';
import cookie from 'react-cookies';
import { AUTH_COOKIE_DOMAIN } from '../constants/auth';

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function stringToFloat(x) {
  return x.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
}

function randomDarkColor() {
  const lum = -0.25;
  let hex = String(`#${Math.random().toString(16).slice(2, 8).toUpperCase()}`).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  let rgb = '#';
  let c;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
    rgb += (`00${c}`).substr(c.length);
  }
  return rgb;
}

function getRandomId() {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}

function getTranslationText(key) {
  let state;
  
  if (typeof window === 'undefined') {
    state = initializeStore(reduxStateWithTranslations);
  } else {
    state = initializeStore();
  }

  const trans = state.getState().language.translations[state.getState().language.language];

  return trans?.find((el) => el.key === key)?.text || '';
}

function getFlag(name) {
  switch (name) {
    case 'ru-RU':
      return <IconFlagRussian />;
    case 'en-US':
      return <IconFlagUSA />;
    default:
      return null;
  }
}

const parseCookie = (str) => str?.split(';').map((v) => v.split('=')).reduce((acc, v) => {
  acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
  return acc;
}, {});

const parseDate = (date, type = 0) => {
  let tempArr = null;

  if (!type) {
    tempArr = date.split('T');
    tempArr[0] = tempArr[0].split('-').reverse().join('.');
    tempArr[1] = tempArr[1].split('.')[0].split(':').slice(0, 2).join(':');
    tempArr = tempArr.join(' ');
  } else {
    tempArr = new Date(date);
    tempArr.setDate(tempArr.getDate() + 1);
  }

  return tempArr;
};
const clearSsrHeaders = (headers) => {
  delete headers['host'];
  delete headers['connection'];
  delete headers['cache-control'];
  delete headers['cache-control'];
  delete headers['dnt'];
  delete headers['accept'];
  delete headers['referer'];
  delete headers['accept-language'];

  return headers;
}

const getCategory = (categories, slug) => {
  if (Array.isArray(categories) && slug && typeof slug === 'string') {
    return categories.find((item) => item.slug.split('__')[0] === slug);
  }

  return undefined;
}

const clearAuthCookie = () => {
  cookie.remove('access_token_market', { path: '/' });
  cookie.remove('access_token', { path: '/', domain: AUTH_COOKIE_DOMAIN });

  //Remove old auth variant cookies
  cookie.remove('access_token', { path: '/' });
  cookie.remove('token_bitteam', { path: '/' });
  cookie.remove('access_token', { path: '/nft' });
  cookie.remove('token_bitteam', { path: '/nft' });
};

export default {
  numberWithCommas,
  getCategory,
  stringToFloat,
  randomDarkColor,
  getRandomId,
  getTranslationText,
  getFlag,
  parseCookie,
  parseDate,
  clearSsrHeaders,
  clearAuthCookie,
};
